import React from 'react';
import footerNavData from '../../../data/footer/footerNav.json';
import paymentMethodData from '../../../data/footer/payment.json';
import socialData from '../../../data/social/index.json';
import { Link } from 'react-router-dom'; // Assuming you're using React Router for routing
import NavCol  from './NavCol/NavCol';
import $ from 'jquery'; 

const Footer = () => {
  const footerLogo = '/assets/img/footer-logo.png';
  const footerNav = [...footerNavData];
  const footerSocial = [...socialData];
  const paymentMethods = [...paymentMethodData];

  return (
    <>
      {/* <!-- BEGIN FOOTER --> */}
      <footer className='footer'>
        <div className='wrapper'>
          <div className='footer-top'>
            <div className='footer-top__social'>
              <span>Find us here:</span>
              <ul>
                {footerSocial.map((social, index) => (
                  <li key={index}>
                    <a href={social.path} target="_blank" rel="noopener noreferrer">
                      <i className={social.icon}></i>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div className='footer-top__logo'>
              <Link to='/'>
                <img src={footerLogo} className='js-img' alt='' />
              </Link>
            </div>

            {/* Payment method */}
            <div className='footer-top__payments'>
              <span>Payment methods:</span>
              <ul>
                {paymentMethods.map((payment, index) => (
                  <li key={index}>
                    <img src={payment.icon} className='js-img' alt='' />
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className='footer-nav'>
            {/* Footer Nav */}
            {footerNav.map((nav, index) => (
              <NavCol nav={nav} key={index} />
            ))}
            <div className='footer-nav__col'>
              <span className='footer-nav__col-title'>Contact</span>
              <ul>
                <li>
                  <i className='icon-map-pin'></i> 1661 Timothy Drive San Leandro, CA 94577
                </li>
                <li>
                  <i className='icon-smartphone'></i>
                  <div className='footer-nav__col-phones'>
                    <a href='tel:(510) 562-5900'>(510) 562-5900</a>
                    <a href='tel:(800) 824-3328'>(800) 824-3328</a>
                  </div>
                </li>
                <li>
                  <i className='icon-mail'></i>
                  <a href='mailto:info@columbiacosmetics.com'>info@columbiacosmetics.com</a>
                </li>
              </ul>
            </div>
          </div>
          <div className='footer-copy'>
            <span>&copy; All rights reserved. Designed and Developed by <a href="https://fixmywebs.com/" target="_blank" className="copyrightlink">Fixmywebs</a></span>
          </div>
        </div>
      </footer>

      <div className="chat">
        <Link to="#">
              <i className="fa-solid fa-comment fa-2x"></i>
        </Link>
      </div>
      {/* <!-- FOOTER EOF   --> */}
    </>
  );
};

export default Footer;
